import { useNavigate, useParams } from "react-router";
import TechAdvantageSection from "../../component/modules/techAdvantageSection/TechAdvantageSection";
import TechEcoSystemSection from "../../component/modules/techEcoSystemSection/TechEcoSystemSection";
import TechFooter from "../../component/modules/techFooter/TechFooter";
import TechHeader from "../../component/modules/techHeader/TechHeader";
import TechHomeSection from "../../component/modules/techHomeSection/TechHomeSection";
import WhyChooseTechnologySection from "../../component/modules/whyChooseTechnologySection/WhyChooseTechnologySection";
import "./index.css";
import { TechnologyType } from "../../utility/types/generaTypes";
import { TECHNOLOGIES_TABS, TECHNOLOGY_PAGE } from "../../utility/utilityData";
import TechMultiplePlatformSection from "../../component/modules/techMultiplePlatformSection/TechMultiplePlatformSection";
import Images from "../../utility/imagePaths";

const Technology = () => {
  const { tech } = useParams<{ tech?: TechnologyType }>();

  const currentTech: TechnologyType = tech ?? "react";
  let currentTechPage = TECHNOLOGY_PAGE[currentTech];

  // const navigate = useNavigate();

  // const currentIndex = TECHNOLOGIES_TABS.findIndex(
  //   (item) => item.type === tech
  // );
  // const safeIndex = currentIndex === -1 ? 0 : currentIndex;

  // const currentTecheee = TECHNOLOGIES_TABS[safeIndex];
  // const prevTech =
  //   TECHNOLOGIES_TABS[
  //     safeIndex > 0 ? safeIndex - 1 : TECHNOLOGIES_TABS.length - 1
  //   ];
  // const nextTech =
  //   TECHNOLOGIES_TABS[
  //     safeIndex < TECHNOLOGIES_TABS.length - 1 ? safeIndex + 1 : 0
  //   ];

  // const handleLeftClick = () => {
  //   navigate(prevTech.to);
  // };

  // const handleRightClick = () => {
  //   navigate(nextTech.to);
  // };

  return (
    <div className="technology_page_container">
      <TechHeader tech={currentTech} />
      <div className="technology_content_container">
        <TechHomeSection homeData={currentTechPage?.homeSection} />
        <WhyChooseTechnologySection
          whyChooseTechData={currentTechPage.whychooseTech}
        />
        {currentTechPage.techMultiplePlatform && (
          <TechMultiplePlatformSection
            TechMultiplePlatformData={currentTechPage.techMultiplePlatform}
          />
        )}
        <TechAdvantageSection
          TechAdvantageData={currentTechPage.techAdvantage}
          style={{
            backgroundColor:
              currentTech === "reactNative" ? " #fbfafa" : "#fff",
          }}
        />
        {currentTechPage.ecoSystem && (
          <TechEcoSystemSection
            ecoSystemData={currentTechPage.ecoSystem}
            style={{
              backgroundColor:
                currentTech === "reactNative" ? "#fff" : " #fbfafa",
            }}
          />
        )}
      </div>
      <TechFooter footerData={currentTechPage.footer} />
      {/* <div className="techHeader_rightContainer gradient_bg" style={{}}>
        <ArrowCard
          isLeft={true}
          label={prevTech.label}
          onclickArrow={handleLeftClick}
        />
        <p className="techHeader_midContainer">{currentTecheee.label}</p>
        <ArrowCard label={nextTech.label} onclickArrow={handleRightClick} />
      </div> */}
    </div>
  );
};

// type ArrowCardProps = {
//   isLeft?: boolean;
//   label: string;
//   onclickArrow: () => void;
// };
// const ArrowCard = ({ isLeft, label, onclickArrow }: ArrowCardProps) => {
//   return (
//     <div className="arrowCard_container" onClick={onclickArrow}>
//       {isLeft && (
//         <img
//           src={Images.SVG_ARROW_RIGHT_GREY_ICON}
//           alt="arowleft"
//           className="arrowGrey"
//           style={{ transform: "rotate(180deg)" }}
//         />
//       )}
//       <p>{label}</p>
//       {!isLeft && (
//         <img
//           src={Images.SVG_ARROW_RIGHT_GREY_ICON}
//           alt="arowright"
//           className="arrowGrey"
//         />
//       )}
//     </div>
//   );
// };
export default Technology;
